import React from "react";
import { reportScreenFailure } from "../lib/diagnostics";

/** Keep error text, tokens and record payloads out of the rendered fallback. */
export default class AppErrorBoundary extends React.Component<React.PropsWithChildren, { failed: boolean; reference: string | null }> {
  state = { failed: false, reference: null as string | null };
  componentDidCatch() { void reportScreenFailure().then(reference => { if(reference)this.setState({reference}); }); }
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="min-h-screen flex items-center justify-center p-6 bg-background text-foreground">
      <div role="alert" className="max-w-md space-y-4">
        <h1 className="text-2xl font-semibold">This screen couldn’t open</h1>
        <p>Reload to try again. Saved records are not removed by reloading. Unsaved changes on this screen may need to be entered again.</p>
        {this.state.reference && <p className="text-sm">Support reference: {this.state.reference}</p>}
        <button onClick={() => window.location.reload()} className="min-h-11 px-4 py-2 bg-forest-600 text-white rounded-lg">Reload</button>
        <a href="/app" className="inline-flex min-h-11 items-center px-4 underline">Return to the app</a>
      </div>
    </main>;
  }
}
